import styled from '@emotion/styled';
import { button, ButtonProps } from '~/utils/styles/mixins/button';
import { margins, MarginsProps } from '~/utils/styles/mixins/margins';
import { shouldForwardProp } from '~/utils/styles/utils';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonProps &
  MarginsProps;

export const Button = styled('button', {
  shouldForwardProp: shouldForwardProp({
    ignore: ['color', 'block'],
  }),
})<Props>`
  ${button}
  ${margins};
`;

Button.defaultProps = {
  type: 'button',
};
